(() => {
  const initScroller = (wrapper) => {
    if (wrapper.dataset.colourSwatchScrollInit === 'true') return;

    const list = wrapper.querySelector('.variant-picker__options--colour');
    if (!list) return;

    wrapper.dataset.colourSwatchScrollInit = 'true';

    const update = () => {
      const canScroll = list.scrollWidth > list.clientWidth + 2;
      wrapper.classList.toggle('colour-swatch-scroll--overflow', canScroll);

      if (!canScroll) {
        wrapper.classList.add('colour-swatch-scroll--at-start');
        wrapper.classList.add('colour-swatch-scroll--at-end');
        return;
      }

      const atEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
      const atStart = list.scrollLeft <= 2;
      wrapper.classList.toggle('colour-swatch-scroll--at-end', atEnd);
      wrapper.classList.toggle('colour-swatch-scroll--at-start', atStart);
    };

    update();
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    if ('ResizeObserver' in window) {
      new ResizeObserver(update).observe(list);
    }
  };

  document.querySelectorAll('[data-colour-swatch-scroll]').forEach(initScroller);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-colour-swatch-scroll]').forEach(initScroller);
  });
})();
